<template>
    <div class="marketing-plan-overview-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <div class="widget-title-container">
                    <j9-overview-svg />
                    <h3>Overview</h3>
                </div>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="isLoading">
                    <loading-screen-svg />
                </div>
                <div v-else>
                    <div class="title-container">
                        <span class="category-color" :style="{ background: marketingPlan.color}" />
                        <h3>{{ marketingPlan.name }}</h3>
                    </div>
                    <div class="grey-bubble leads-bubble">
                        <!-- <div class="leads-container">
                            <j3-leads-svg />
                            <div class="average-leads-content">
                                <p class="heavy-weight">Average leads across your contact pool</p?>
                                <p>20 leads from 1000 contacts</p>
                            </div>
                            <grey-info-icon-svg class="info-icon"/>
                        </div> -->

                        <div class="duration-container">
                            <q7-calendar-svg />
                            <div class="duration-content">
                                <p class="heavy-weight">Duration</p>
                                <p>{{marketingPlan.duration}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="description-container">
                        {{marketingPlan.description}}
                    </div>
                    <div class="grey-bubble campaign-bubble">
                        <h4>Campaigns in this Marketing Plan ({{marketingPlan.campaigns.length}})</h4>
                        <div class="preview-imgs-container">
                            <div v-for="campaign in marketingPlan.campaigns" :key="campaign.id" class="campaigns-container">
                                <div class="preview-img-container" @click="previewContent(campaign)">
                                    <div class="preview-overlay"><eye-svg /></div>
                                    <img class="preview-img" :src="campaign.previewImageUrl | templatePreviewImagePlaceholder" />
                                </div>
                                <p class="send-date" >{{campaign.scheduledSendDate  | momentDateMMMDoYYYY}}</p>
                                <p class="campaign-name" @click="viewMarketingPlanCalendar()">{{campaign.name}}</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button class="save-btn" @click="viewMarketingPlanCalendar()">
                        View Calendar
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const InfoIconSvg = () => import('@/components/svg/grey-info-icon-svg');
const J3LeadsSvg  = () => import('@/components/svg/grid/j3-leads-svg');
const Q7CalendarSvg  = () => import('@/components/svg/grid/q7-calendar-svg');
const J9OverviewSvg  = () => import('@/components/svg/grid/j9-overview-svg');
const EyeSvg = () => import('@/components/svg/eye-svg');
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'marketing-plan-overview-widget',

    props: {
        widget: {
            type: Object,
            required: true
        },
        config: {
            type: Object
        },
        marketingPlanId: {
            type: Number
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'j3-leads-svg': J3LeadsSvg,
        'q7-calendar-svg': Q7CalendarSvg,
        'j9-overview-svg': J9OverviewSvg,
        'grey-info-icon-svg': InfoIconSvg,
        'eye-svg': EyeSvg
    },

    data() {
        return {
            isLoading: false,
            marketingPlan: {
                name: null,
                duration: 0,
                description: null,
                campaigns: 0,
            }
        }
    },
    methods: {
         executeQuery() {
            this.isLoading = true;

            this.$api
                .get(`/service/MarketingPlans?$expand=MarketingPlanCampaigns($select=Campaign;$expand=Campaign($select=ScheduledSendDate,Id,PreviewImageUrl,Name))&$filter=Id eq ${this.widget.marketingPlanId} `)
                .then(response => {
                    var dataResponseItem = response.data.value[0];
                        var mpcResponse = dataResponseItem.MarketingPlanCampaigns || [];

                        var sendDates = mpcResponse
                            .filter(mpc => mpc.Campaign.ScheduledSendDate)
                            .map(mpc => {
                                return this.$moment(mpc.Campaign.ScheduledSendDate).local();
                            });

                        var duration = '';

                        if (sendDates.length === 1){
                            duration = 'a day';
                        } 

                        else if (sendDates.length > 1) {
                            var end =  this.$moment.max(sendDates);
                            var start =  this.$moment.min(sendDates);
                            duration = this.$moment.duration(start.diff(end)).humanize();
                        }

                        if (duration.length > 0 && duration[0] === 'a') {
                            duration = '1' + duration.slice(1);
                        }

                        var campaigns = mpcResponse.map(mpc =>{
                            return {
                                id : mpc.Campaign.Id,
                                name: mpc.Campaign.Name,
                                previewImageUrl : mpc.Campaign.PreviewImageUrl,
                                scheduledSendDate : this.$moment(mpc.Campaign.ScheduledSendDate)
                            }
                        });

                        this.marketingPlan.id = dataResponseItem.Id;
                        this.marketingPlan.name = dataResponseItem.Name;
                        this.marketingPlan.color = dataResponseItem.Color;
                        this.marketingPlan.description = dataResponseItem.Description;
                        this.marketingPlan.campaigns = campaigns;
                        this.marketingPlan.campaignsSent = mpcResponse.filter(mpc => mpc.Campaign.DateSent).length;
                        this.marketingPlan.duration = duration;
                    
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to get Marketing Plan.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                })
        }, 

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        previewContent(campaign) {
            window.open(`/Campaigns/${ campaign.id }/preview`, '_blank');
        },

        viewMarketingPlanCalendar() {
            this.$router.push(`/MarketingPlans/${ this.marketingPlan.id }/Calendar`);
            this.closeWidget();
        }
    },

    created() {
        this.executeQuery();
    }
}
</script>

<style>
.marketing-plan-overview-widget .heavy-weight {
    font-weight: 600;
}

.marketing-plan-overview-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.marketing-plan-overview-widget .cancel-btn:hover {
    background: #E9E9EF;
}

.marketing-plan-overview-widget .grey-bubble {
    background: #F7F7F8;
    border-radius: 15px;
    padding: 17px 28px 10px;
}

.marketing-plan-overview-widget .leads-bubble {
    display: flex;
    justify-content: flex-start;
}

.marketing-plan-overview-widget .leads-container,
.marketing-plan-overview-widget .duration-container,
.marketing-plan-overview-widget .title-container{
    display: flex;
}

.marketing-plan-overview-widget .preview-imgs-container {
    display: flex;
    flex-wrap: wrap;
}

.marketing-plan-overview-widget .average-leads-content p {
    color: #EB7E0A;
    font-size: 14px;
    line-height: 1em;
    margin-bottom: 7px;
}

.marketing-plan-overview-widget .duration-content p {
    font-size: 14px;
    line-height: 1em;
    text-align: right;
    margin-bottom: 3px;
}

.marketing-plan-overview-widget .j3-leads-svg {
    width: 60px;
    height: auto;
    margin-right: 15px;
}

.marketing-plan-overview-widget .grey-info-icon {
    width: 22px;
    margin-left: 15px;
    margin-top: -7px;
    position: relative;
}

.marketing-plan-overview-widget .grey-info-icon text {
    fill: #CAC6CB;
}

.marketing-plan-overview-widget .grey-info-icon ellipse {
    stroke: #CAC6CB;
}

.marketing-plan-overview-widget .description-container {
    font-size: 14px;
    padding: 17px;
}

.marketing-plan-overview-widget .q7-calendar-svg {
    margin-right: 15px;
}

.marketing-plan-overview-widget .preview-img-container {
    width: 93px;
    height: 63px; 
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    margin-bottom: 8px;
    cursor: pointer;
}

.marketing-plan-overview-widget .send-date {
    font-size: 11px;
    text-align: center;
    margin-bottom: 0px;
}

.marketing-plan-overview-widget .campaigns-container {
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px; 
    max-width: 93px;
} 

.marketing-plan-overview-widget .campaign-bubble h4 {
    margin-bottom: 15px;
}

.marketing-plan-overview-widget .preview {
    width: 160px;
    height: 165px;
    overflow: hidden;
    border-radius: 18px;
    margin: 0 auto;
}

.marketing-plan-overview-widget  .preview {
    position: relative;
    cursor: pointer;
}
.marketing-plan-overview-widget  .preview-overlay {
    position: absolute;
    display: flex;         /* NEW, Spec - Firefox, Chrome, Opera */
    align-items: center;
    justify-content: center;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    background-color: rgba(89, 72, 110, 1);
    transition: opacity 500ms ease-out;
}

.marketing-plan-overview-widget  .preview-overlay:hover {
    opacity: 0.8;
}

.marketing-plan-overview-widget  .preview-overlay .preview-text {
    position: relative;
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    z-index: 1;
}

.marketing-plan-overview-widget .eye-svg {
    width: 22.77px;
    top: 10px;
    right: 15px;
}
.marketing-plan-overview-widget .eye-svg path,
.marketing-plan-overview-widget .eye-svg circle{
    fill: #fff;
}

.marketing-plan-overview-widget .category-color {
    width: 10px;
    height: 10px;
    border-radius: 200px;
    margin-left: 10px;
    position: relative;
    top: 5px;
    margin-right: 8px;
}

.marketing-plan-overview-widget .widget-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.marketing-plan-overview-widget .j9-overview-svg {
    position: relative;
    margin-right: 28px;
}

.marketing-plan-overview-widget .campaign-name {
    font-size: 11px;
    line-height: 1em;
    color: #18AEFF;
    cursor: pointer;
}
</style>